module.exports = __webpack_public_path__ + "img/azuread.bbfe3948.svg";